export const SYSTEM_SETTINGS_SEARCH_PARAM = "system-settings";
export const TOKEN_MANAGEMENT_SECTION = "token management";
// ModalWithNavigation lowercases section ids — keep this lowercase.
export const INTEGRATIONS_SECTION = "integrations";

// Wide, table-based sections that need more room than the settings form.
export const WIDE_SECTIONS: string[] = [
  TOKEN_MANAGEMENT_SECTION,
  INTEGRATIONS_SECTION,
];

export const SECTIONS_WITH_TEST_EMAIL: string[] = ["notifications"];
export const CONTROL_PLANE_SECTION = "control plane";
